import { resetDestroyCheckBox, showCardOnLoad, destroyCard, showFirstHiddenCard } from "../documents.js";

$(document).ready(() => {
  if ($('.legal-step10').length) {
    const addDocument = $('.add-tax-reports');
    const destroyDocument = $('.delete-document');

    resetDestroyCheckBox();
    showCardOnLoad(addDocument);
    addDocument.on('click', e => showFirstHiddenCard($(e.target)));
    destroyDocument.on('click', e => destroyCard($(e.target), '.add-tax-reports'));
  }
});
